import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  loaderService,
  ssDialogService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
// import performBusinessImpactAnalysisDialog from '../impactAnalysis/dialog.performBusinessImpactAnalysisDialog';
// import assessmentAnalysisDateMessagesTpl from '../messages/assessment.analysis-date.messages.html';
import assessmentNameMessagesTpl from '../messages/assessment.name.messages.html';
import validator, { name as validatorName } from '../messages/assessment-unique-name.validator.directive';
import controller from './add-assessment-dialog.controller';
import template from './add-assessment-dialog.html';

class dialogService {
  getOptions($event, { assessment, settings }) {
    return {
      controller,
      controllerAs: 'addAssessmentDialogVM',
      locals: {
        assessment,
        settings
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.pra.addAssessmentDialog', [
  alerts,
  confirmDialog,
  bcpDataService,
  loaderService,
  constants,
  // performBusinessImpactAnalysisDialog,
  ssDialogService,
])
  .directive(validatorName, validator)
  .service('addPraAssessmentDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('assessment.name.messages.html', assessmentNameMessagesTpl);
  })
  .name;
